module.exports = __webpack_public_path__ + "img/0xa4FFfc757e8c4F24E7b209C033c123D20983Ad40.e3bb18ec.png";